import {useContext} from 'react'

import { FichaPlantillaModalFormWrapper } from './FichaPlantillaModalFormWrapper'
import { FichaPlantillaModalHeader } from './FichaPlantillaModalHeader'
import { PartnerContext } from '../PartnerContexts'

const FichaPlantillaEditModal = () => {

  const {isFichaPlantillaModalOpen} = useContext(PartnerContext)

  return (
    <>
      {isFichaPlantillaModalOpen && (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
              {/* begin::Modal dialog */}
              <div className='modal-dialog modal-dialog-centered modal-md'>
                {/* begin::Modal content */}
                <div className='modal-content'>
                  <FichaPlantillaModalHeader />
                  {/* begin::Modal body */}
                  <div className='modal-body scroll-y mx-5 mx-xl-5 my-2'>
                    <FichaPlantillaModalFormWrapper />
                  </div>
                  {/* end::Modal body */}
                </div>
                {/* end::Modal content */}
              </div>
              {/* end::Modal dialog */}
            </div>
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </>
      )}
    </>
  )
}

export {FichaPlantillaEditModal}
